import { template as template_aa4bd128f26943e881e77de316e0a08b } from "@ember/template-compiler";
import { contactWizardHeadingKey } from 'client-portal/utils/contact/wizard-steps';
import { service } from '@ember/service';
import Captcha from 'client-portal/components/captcha';
import Component from '@glimmer/component';
import LegalDisclaimer from './information/legal-disclaimer';
import SubmitButton from './submit-button';
import t from 'ember-intl/helpers/t';
export default class ContactWizard extends Component {
    @service
    contactSteps;
    get headingKey() {
        return contactWizardHeadingKey(this.contactSteps.currentStep);
    }
    get stepNumber() {
        return this.contactSteps.activeIndex + 1;
    }
    get totalSteps() {
        return this.contactSteps.steps.length;
    }
    get showNextButton() {
        return this.contactSteps.isEnabled && !this.contactSteps.isLast;
    }
    get showRecaptcha() {
        return !this.args.client?.skipRecaptchaValidation;
    }
    get stackRecaptcha() {
        return this.showRecaptcha && this.contactSteps.isEnabled && this.contactSteps.isLast;
    }
    get showInlineRecaptcha() {
        return this.showRecaptcha && !this.contactSteps.isEnabled;
    }
    get primaryButtonLabel() {
        if (this.showNextButton) {
            return 'contact.wizard.next';
        }
        return this.args.saving ? 'contact.sending' : 'contact.sendMessage';
    }
    get isPrimaryDisabled() {
        return Boolean(this.args.saving || this.args.isLoading);
    }
    onPrimaryAction = ()=>{
        if (this.isPrimaryDisabled) {
            return;
        }
        if (this.showNextButton) {
            this.args.onNext?.();
            return;
        }
        this.args.save?.();
    };
    static{
        template_aa4bd128f26943e881e77de316e0a08b(`
    {{#if this.contactSteps.isEnabled}}
      <div class="wizard-header" data-test-contact-wizard-header>
        <h4 class="title" data-test-contact-wizard-title>
          {{t this.headingKey}}
        </h4>
        <p class="subtitle">
          <span class="d-none d-sm-inline" data-test-contact-wizard-step-indicator>
            {{t "contact.wizard.stepIndicator" current=this.stepNumber total=this.totalSteps}}
          </span>
          <span class="d-sm-none" data-test-contact-wizard-step-indicator-mobile>
            {{t "contact.wizard.stepIndicatorMobile" current=this.stepNumber total=this.totalSteps}}
          </span>
        </p>
      </div>
    {{/if}}

    <div class={{if this.contactSteps.isEnabled "wizard-body"}}>
      {{yield}}
    </div>

    {{#if this.contactSteps.isEnabled}}
      <p class="legal-warning wizard-emergency" data-test-contact-wizard-emergency>
        {{t "contact.emergencyWarning"}}
      </p>
      {{#if this.contactSteps.isLast}}
        <div class="wizard-legal" data-test-contact-wizard-legal>
          <LegalDisclaimer @hideEmergency={{true}} />
        </div>
      {{/if}}
    {{/if}}

    <div class="footer{{if this.contactSteps.isEnabled ' wizard-footer'}}">
      {{#if this.stackRecaptcha}}
        <div class="wizard-recaptcha offset-bottom" data-test-contact-wizard-recaptcha>
          <Captcha @model={{@client}} />
        </div>
      {{/if}}
      <div class="row justify-content-between">
        <div class="col-sm-5">
          {{#if this.showInlineRecaptcha}}
            <Captcha @model={{@client}} />
          {{/if}}
        </div>

        <div class="col-sm-4">
          <SubmitButton
            @onClick={{this.onPrimaryAction}}
            @isSaving={{@saving}}
            @disabled={{@isLoading}}
            data-test-contact-wizard-next={{if this.showNextButton ""}}
          >
            {{t this.primaryButtonLabel}}
          </SubmitButton>
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
